// extracted by mini-css-extract-plugin
export default {"description":"style_description__wAmgL","fade-in":"style_fade-in__gmdDb","top":"style_top__elSXw","image":"style_image__lGLmn"};